<template>
    <div class="modal-container">
      <loading-spinner v-if="isLoading"></loading-spinner>
        <div ref="modalContainer">
            <div class="form-content-body">
                <div class="row">
                    <div
                            class="col-md-12 text-center modal-header px-5 align-items-center"
                    >
                        <div class="header-container row w-100">
                            <h3 class="col-11 text-left">Purchase order details</h3>
                            <div class="close close-btn text-right col-1">
                                <img src="../../assets/images/icon-close.svg" class="cursor-pointer" @click="onBackToParent">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class=" invoice-modal-body">
            <div class="row no-gutters py-3">
                <div class="col-12">
                      <span @click="navigateToBackPage" class="solution-link " >
                        <font-awesome-icon icon="arrow-left" size="sm"/>
                          Back
                      </span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 mb-2">
                    <span class="modal-sub-title ">{{purchaseOrder.supplierName}}</span>
                </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div :class="detailModal.titleClass">
                    <span class="modal-label">Supplier ID</span>
                  </div>
                  <div :class="detailModal.descriptionClass">
                    <span>{{purchaseOrder.supplierNumber | naIfEmpty}}</span>
                  </div>
                </div>
              </div>
                <div class="col-md-6">
                    <div class="row">
                        <div :class="detailModal.titleClass">
                            <span class="modal-label">Purchase order number</span>
                        </div>
                        <div :class="detailModal.descriptionClass">
                            <span>{{purchaseOrder.poNumber | naIfEmpty}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div :class="detailModal.titleClass">
                            <span class="modal-label">Requisition number</span>
                        </div>
                        <div :class="detailModal.descriptionClass">
                            <span>{{purchaseOrder.requisitionNumber | naIfEmpty}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div :class="detailModal.titleClass">
                            <span class="modal-label">Purchase order status</span>
                        </div>
                        <div :class="detailModal.descriptionClass">
                            <span>{{ purchaseOrder.status | ehTruncateHTML(20) }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div :class="detailModal.titleClass">
                      <header-with-tooltip :tooltipText="FORM_LABELS.TOOLTIPS.dateTooltip"><span class="modal-label mr-1">Purchase order date</span></header-with-tooltip>
                    </div>
                    <div :class="detailModal.descriptionClass">
                      <span>{{purchaseOrder.docDate}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div :class="detailModal.titleClass">
                        <span class="modal-label">Purchase order amount</span>
                    </div>
                    <div :class="detailModal.descriptionClass">
                      <span><strong>{{purchaseOrder.poCurrency}}</strong> {{purchaseOrder.netValue}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div :class="detailModal.titleClass">
                      <span class="modal-label">Purchase order amount in USD</span>
                    </div>
                    <div :class="detailModal.descriptionClass">
                      <span>{{purchaseOrder.netValueInUsd}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div :class="detailModal.titleClass">
                          <header-with-tooltip :tooltipText="FORM_LABELS.TOOLTIPS.remainingAmountToolTip"><span class="modal-label mr-1">Remaining amount</span></header-with-tooltip>
                        </div>
                        <div :class="detailModal.descriptionClass">
                            <span><strong>{{purchaseOrder.poCurrency}}</strong> {{purchaseOrder.remainingValue}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div :class="detailModal.titleClass">
                            <span class="modal-label">Remaining amount in USD</span>
                        </div>
                        <div :class="detailModal.descriptionClass">
                            <span>{{purchaseOrder.remainingValueInUsd | naIfEmpty}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div :class="detailModal.titleClass">
                            <span class="modal-label">Requested by</span>
                        </div>
                        <div :class="detailModal.descriptionClass">
                            <user-full-name v-if="purchaseOrder.requestedBy" :user-detail="getUserDetail(purchaseOrder.requestedBy)"></user-full-name>
                            <span v-else>N/A</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div :class="detailModal.titleClass">
                            <span class="modal-label">Created by</span>
                        </div>
                        <div :class="detailModal.descriptionClass">
                            <user-full-name v-if="purchaseOrder.createdBy" :user-detail="getUserDetail(purchaseOrder.createdBy)"></user-full-name>
                            <span v-else>N/A</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="po-allocation-data-container">
            <vue-good-table
                    :columns="columns"
                    :rows="purchaseOrder.poAdditionalData"
                    :pagination-options="{enabled: this.paginationEnabled,perPage: PER_PAGE_SIZE}"
                    :sort-options="{
                    enabled: true,
                  }"
                    ref="invoices-table"
            >
                <div slot="emptystate">No Items are available to display.</div>

                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field==='costCenterFbp' || props.column.field==='costCenterOwner'">
                        <div>
                            <user-full-name :user-detail="getUserDetail(props.formattedRow[props.column.field])"></user-full-name>
                        </div>
                    </span>
                    <span v-else>
                         <span v-if="props.column.field!='costCenter'">
                            <strong>{{props.row.invoiceCurrency}}</strong>
                         </span>
                      {{props.formattedRow[props.column.field]}}
                    </span>
                </template>
            </vue-good-table>
        </div>

        <invoices v-if="filteredInvoices && filteredInvoices.length > 0" :invoices="filteredInvoices" @onRouteToInvoiceModal="routeToInvoiceModal"/>

      <div v-if="!isLoading" class="row no-gutters d-block pl-md-3 pl-1 ml-1 pb-4 font-italic">
        <span>Purchase orders are archived after {{CONSTANTS.MONTHS_WORTH_OF_DASHBOARD_DATA}} months and are no longer accessible. Please contact <a :href="CONSTANTS.ACCOUNTS_PAYABLE_SLACK" target="_blank"><strong class="solution-link">Accounts Payable via Lumi</strong></a> for more information</span>
      </div>

    </div>
</template>

<script>
    import { VueGoodTable } from "vue-good-table";
    import CONSTANTS from "@/store/constants";
    import { mapGetters,mapActions } from "vuex"
    import UserFullName from "../UserFullName";
    import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
    import InvoicesAndPOMixin from "@/mixins/InvoicesAndPOMixin";
    import Invoices from "@/components/InvoiceAndPurchaseOrders/Invoices";
    import LoadingSpinner from "@/components/LoadingSpinner";
    import InvoicesPOFiltersMixin from "@/mixins/InvoicesPOFiltersMixin";

    export default {
        name: "PoDetailModal",
        props: ['purchaseOrder'],
        mixins: [PaymentFormsMixin, InvoicesAndPOMixin, InvoicesPOFiltersMixin],
        components: {UserFullName, VueGoodTable, Invoices, LoadingSpinner},
        computed:{
            ...mapGetters(["isLoading","currentUser", "userData", "purchaseOrdersFormattedList","formattedInvoices", "prevRoute", "poTableUserPreferences"]),
            paginationEnabled() {
                return this.invoicePODetails&&this.invoicePODetails.length > CONSTANTS.PAGINATION_THRESHOLD_FIVE
            },
            filteredInvoices() {
              let filteredInvoices = []
              this.formattedInvoices.forEach(invoice => {
                if(invoice.multiplePOCount > 1) {
                  if(invoice.poNumber.includes(this.purchaseOrder.poNumber)) {
                    filteredInvoices.push(invoice)
                  }
                } else if (invoice.poNumber === this.purchaseOrder.poNumber) {
                    filteredInvoices.push(invoice)
                }
              })
              return filteredInvoices
            },
        },
        created(){
            this.getPurchaseOrdersByPONumbers();
            this.getInvoices()
        },
        beforeDestroy() {
          this.onBackToParent()
        },
      methods:{
        ...mapActions(["fetchPurchaseOrders", "fetchInvoiceDashboardData"]),
        navigateToBackPage() {
          this.userClickedEvent = true
          this.$emit('close')
          this.$router.go(-1)
        },
        routeToInvoiceModal() {
          this.userClickedEvent = true
          this.onBackToParent()
        },
        async getInvoices() {
          if(!this.formattedInvoices || this.formattedInvoices.length===0){
            await this.fetchInvoiceDashboardData()
          }
        },
        onBackToParent(){
          if(this.userClickedEvent) {
            this.$modal.hide('poDetailModal')
          } else {
            this.$emit('close')
            if(this.prevRoute && this.prevRoute.includes(CONSTANTS.INVOICES_ROUTE)) {
              this.routeToInvoices()
            } else {
              this.routeToPurchaseOrders()
            }
          }
        },
        async getPurchaseOrdersByPONumbers(){
          if(!this.purchaseOrdersFormattedList || this.purchaseOrdersFormattedList.length===0) {
                await this.fetchPurchaseOrders();
            }
          if(Object.keys(this.poTableUserPreferences).length === 0) {
            await this.getAllNamesForFilter()
          }
        }
        },
        data() {
            return {
                userClickedEvent: false,
                PER_PAGE_SIZE: CONSTANTS.PAGINATION_THRESHOLD_FIVE,
                columns:
                    [
                        {
                            label: "Cost center",
                            field: "costCenter",
                            type: "string",
                            thClass: "width-sm",
                            tdClass: "align-left text-break ",
                            width: "9%",
                            sortable: true
                        },
                        {
                            label: "Cost center owner",
                            field: "costCenterOwner",
                            type: "string",
                            thClass: "width-sm hide-field-xs",
                            tdClass: "align-left wrap-text hide-field-xs",
                            width: "11%",
                            sortable: true,
                        },
                        {
                            label: "Cost center finance business partner",
                            field: "costCenterFbp",
                            type: "string",
                            thClass: "width-sm hide-field-xs",
                            tdClass: "align-left wrap-text hide-field-xs",
                            width: "11%",
                            sortable: true,
                        },
                        {
                            label: "Allocated amount",
                            type: "string",
                            field: "allocatedAmount",
                            thClass: "width-sm",
                            tdClass: "align-left wrap-text",
                            width: "10%",
                            html: true
                        },
                        {
                            label: "Utilized amount",
                            field: "invoicedAmount",
                            type: "string",
                            thClass: "width-sm hide-field-xs",
                            tdClass: "align-left hide-field-xs",
                            width: "9%"
                        },
                        {
                            label: "Unutilized amount",
                            field: "unutilizedAmount",
                            type: "string",
                            thClass: "width-sm ",
                            tdClass: "align-left",
                            width: "9%"
                        }
                    ]
            }
        }
    }
</script>
<style>
  .po-allocation-data-container {
    background-color: #fff;
    padding:15px;
    min-height: 100px;
  }

  @media (max-width: 1000px) {
      .app-modal {
          left: 0px !important;
          width: 100% !important;
          overflow-y: auto !important;
      }
  }
</style>
<style scoped>
    .modal-container{
        min-height:500px;
        background: #FFFFFF;
    }
    .modal-label{
        font-family: artifaktElementBold;
    }
    .modal-sub-title{
        font-size: 20px;
    }
    .invoice-modal-body{
        background-color: #E7F4FF;
        padding:0px 30px 30px 20px;
    }


</style>
<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>